import React from "react";
import "./PriceComponent.css";

const PriceComponent = ({ error, combination }) => {
  return (
    <section className="PriceComponent">
      {combination ? (
        <>
          <div className="top_price_sect">
            <p className="selling_price">
              ₹{(Number(combination?.total) || 0).toFixed(2)}  {" "}
              <span className="note_text">inclusive of all taxes</span>
            </p>
          </div>

          <div className="qty_holder">
            <p className="qty_text">
              for {combination?.Qty?.name} Qty{" "}
              <span className="piece_text">
              {(Number(combination?.per_piece) || 0).toFixed(2)}/ piece
                {/* (₹{combination?.per_piece} / piece) */}
              </span>
            </p>
          </div>
        </>
      ) : (
        <p className="error_text" style={{ color: "red", fontWeight: "bold" }}>
          {error}
        </p>
      )}
    </section>
  );
};

export default PriceComponent;
